import ReactECharts from 'echarts-for-react'

interface BarChartProps {
  title: string
  data: number[]
  categories: string[]
  color?: string
  height?: string
  formatter?: (value: number) => string
  xAxisMin?: number
  xAxisMax?: number
  fullNames?: string[]
}

export function BarChart({
  title,
  data,
  categories,
  color = '#3b82f6',
  height = '175px',
  formatter,
  xAxisMin,
  xAxisMax,
  fullNames,
}: BarChartProps) {
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderColor: '#e5e7eb',
      borderWidth: 1,
      textStyle: {
        color: '#374151',
        fontSize: 12,
      },
      formatter: formatter
        ? function (params: { dataIndex: number; name: string; seriesName: string; value: number }[]) {
            const fullName = fullNames?.[params[0].dataIndex] || params[0].name
            return `${fullName}<br/>${params[0].seriesName}: <b style="color: ${color}">${formatter(params[0].value)}</b>`
          }
        : function (params: { dataIndex: number; name: string; seriesName: string; value: number }[]) {
            const fullName = fullNames?.[params[0].dataIndex] || params[0].name
            return `${fullName}<br/>${params[0].seriesName}: <b style="color: ${color}">${params[0].value}</b>`
          },
    },
    xAxis: {
      type: 'value',
      min: xAxisMin,
      max: xAxisMax,
    },
    yAxis: {
      type: 'category',
      data: categories,
      axisLabel: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },
    },
    grid: {
      left: '5%',
      right: '8%',
      bottom: '5%',
      top: '15%',
      containLabel: true,
    },
    series: [
      {
        name: title,
        type: 'bar',
        data: data,
        itemStyle: {
          color: color,
        },
        emphasis: {
          itemStyle: {
            color: color,
            opacity: 0.9,
            shadowBlur: 4,
            shadowColor: color,
          },
        },
        label: {
          show: data.length < 10,
          position: 'right',
          color: '#999',
          fontSize: 10,
          fontWeight: 'normal',
          formatter: function (params: { dataIndex: number }) {
            return categories[params.dataIndex]
          },
        },
        barMaxWidth: '80%',
      },
    ],
  }

  return (
    <div className="bg-white rounded-lg shadow-sm p-3">
      <div className="flex items-center justify-center gap-1 mb-3 text-heading font-semibold text-gray-800">{title}</div>
      <ReactECharts option={option} style={{ height }} />
    </div>
  )
}
